/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ResponseObject,
  ResponseObject$inboundSchema,
  ResponseObject$Outbound,
  ResponseObject$outboundSchema,
} from "./responseobject.js";

export type ResponseQueuedEvent = {
  type: "response.queued";
  sequenceNumber: number;
  response: ResponseObject;
};

/** @internal */
export const ResponseQueuedEvent$inboundSchema: z.ZodType<
  ResponseQueuedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.queued"),
  sequence_number: z.number().int(),
  response: ResponseObject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
  });
});
/** @internal */
export type ResponseQueuedEvent$Outbound = {
  type: "response.queued";
  sequence_number: number;
  response: ResponseObject$Outbound;
};

/** @internal */
export const ResponseQueuedEvent$outboundSchema: z.ZodType<
  ResponseQueuedEvent$Outbound,
  z.ZodTypeDef,
  ResponseQueuedEvent
> = z.object({
  type: z.literal("response.queued"),
  sequenceNumber: z.number().int(),
  response: ResponseObject$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
  });
});

export function responseQueuedEventToJSON(
  responseQueuedEvent: ResponseQueuedEvent,
): string {
  return JSON.stringify(
    ResponseQueuedEvent$outboundSchema.parse(responseQueuedEvent),
  );
}
export function responseQueuedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseQueuedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseQueuedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseQueuedEvent' from JSON`,
  );
}
